import { defineComponent as _defineComponent } from 'vue'
import { AbTitle, AbButton, AbDescription, AbVideo } from '../../../ui';
import { useCdnImg } from '@webplatform/cdn-image';

interface Props {
  name?: string;
  text?: string;
  image?: string;
  title?: string;
  video?: string;
  button: {
    text: string;
    isVisible?: boolean;
    isVideoOpener?: boolean;
    link?: string;
    target?: string;
  };
  videoId?: string;
  features: {
    icon: string;
    text?: string;
    title: string;
    iconMobile: string;
  }[];
  featuresText?: string;
}

interface Emits {
  (e: 'play', data?: string): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionVideoTabsSlide',
  props: {
    name: null,
    text: null,
    image: null,
    title: null,
    video: null,
    button: null,
    videoId: null,
    features: null,
    featuresText: null
  },
  emits: ["play"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'play', data?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  name?: string;
  text?: string;
  image?: string;
  title?: string;
  video?: string;
  button: {
    text: string;
    isVisible?: boolean;
    isVideoOpener?: boolean;
    link?: string;
    target?: string;
  };
  videoId?: string;
  features: {
    icon: string;
    text?: string;
    title: string;
    iconMobile: string;
  }[];
  featuresText?: string;
};




const { generateUrl } = useCdnImg();
const playVideo = () => {
  emit('play', props.videoId);
};

return { __sfc: true,props, emit, generateUrl, playVideo, AbTitle, AbButton, AbDescription, AbVideo }
}

})